import { Directive } from '@angular/core';

@Directive({
  selector: '[uiTimelineItemDef]',
  standalone: true
})
export class TimelineItemDefDirective {}
